import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utilitário padrão do shadcn/ui — combina `clsx` (composição condicional de
 * classes) com `tailwind-merge` (dedup de classes conflitantes do Tailwind).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
